export const selectPreservingRecommendation = (previousRecommendation, recommendations) => {
  const previousCode = previousRecommendation && previousRecommendation.issue_code;
  const stillMatches = previousCode && recommendations.find(rec => rec.issue_code === previousCode);
  return stillMatches || recommendations[0];
};
